module.exports = __webpack_public_path__ + "static/media/assignments.514abc5c.svg";